var exports = {
  "RC": "xdbfd91f1--b7fd4d--preloader",
  "fD": "xdbfd91f1--b7fd4d--preloader-content",
  "L2": "xdbfd91f1--b7fd4d--preloader-img_item",
};

module.exports = exports;
